import { apiClient } from '@libs/apiRequest';
import { setCookie } from '@libs/cookies';
import { parseJwt, parseTokenExpireFullTime, parseTokenExpireTime } from '@libs/parseJWT';

import { AUTH_TOKEN_KEY, AUTH_TOKEN_TIME, REFRESH_TOKEN_KEY } from './common';

/**
 * Exchanges a Microsoft id_token for the app's own JWTs, stores them in cookies, marks the
 * session as Microsoft-originated, and returns the parsed auth data (for setAuthData).
 * Shared by the popup handler (Login.jsx) and the redirect-return handler (auth/index.jsx).
 */
export async function completeMicrosoftLogin(idToken) {
    const { data } = await apiClient({
        url: 'auth/microsoft/token',
        method: 'post',
        data: JSON.stringify({ id_token: idToken })
    });

    const { authToken, refreshToken } = data;
    const parsedAuthData = parseJwt(authToken);

    setCookie(AUTH_TOKEN_KEY, authToken, parseTokenExpireTime(authToken));
    setCookie(AUTH_TOKEN_TIME, JSON.stringify({ exp: parseTokenExpireFullTime(authToken) }));
    setCookie(REFRESH_TOKEN_KEY, refreshToken, parseTokenExpireTime(refreshToken));

    // Mark that this login was performed via Microsoft SSO (used by logout to sign out of MS too).
    try { localStorage.setItem('auth_provider', 'microsoft'); } catch (e) { /* ignore */ }

    return parsedAuthData;
}
